import ModalViewModel from 'infra/ModalViewModel'

import { action, computed, makeObservable, observable } from 'mobx'

export interface ActionError {
  jobId: string
  jobTitle: string
  error: string
}

export default class BulkActionJobErrorViewModel extends ModalViewModel {
  @observable errors: ActionError[] = []

  constructor() {
    super()
    makeObservable(this)
  }

  @computed
  get hasErrors() {
    return this.errors.length > 0
  }

  @action.bound
  showErrors(errors: ActionError[]) {
    this.errors = errors
    super.show()
  }
}
